import {
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectionStrategy,
  Component,
  type ElementRef,
  computed,
  effect,
  inject,
  signal,
  viewChild,
} from '@angular/core';
import { getLocalePreference } from '@em-helpers';
import '@visma-swno/gaia-chat-ui';
import { GaButtonModule, GaCardModule } from '@vsn-ux/ngx-gaia';

import { environment } from '../../../environments/environment';
import { VismaOAuthService } from '../../core/services/visma-oauth.service';

@Component({
  selector: 'di-gaia-assistant',
  imports: [GaCardModule, GaButtonModule],
  templateUrl: './gaia-assistant.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GaiaAssistantComponent {
  private readonly vismaOAuthService = inject(VismaOAuthService);

  protected readonly baseUrl = environment.assistant.apiBaseUrl;
  protected readonly profileId = environment.assistant.profileId;
  protected readonly isOpenSignal = signal(false);

  private readonly gaiaChatElementSignal = viewChild<ElementRef>('gaiaChat');

  // Use signals directly from the service
  protected readonly accessTokenSignal = this.vismaOAuthService.accessTokenSignal;
  protected readonly isAuthenticatedSignal = this.vismaOAuthService.isAuthenticatedSignal;

  // Extract language code for gaia-chat (nb-NO → nb, en-GB → en)
  protected readonly languageCodeSignal = computed(() => {
    const locale = getLocalePreference();
    return locale.split('-')[0];
  });

  constructor() {
    effect(() => {
      const chatElement = this.gaiaChatElementSignal();
      const isAuthenticated = this.isAuthenticatedSignal();

      if (chatElement?.nativeElement) {
        chatElement.nativeElement.tokenProvider = isAuthenticated ? this.accessTokenSignal : null;
      }
    });
  }

  open() {
    this.isOpenSignal.set(true);
  }

  close() {
    this.isOpenSignal.set(false);
  }

  toggle() {
    this.isOpenSignal.update((current) => !current);
  }
}
